var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hex_img"},[(!_vm.isDcomm)?_c('img',{staticClass:"hex_img",attrs:{"src":require("@/assets/hex.svg")}}):_c('img',{staticClass:"hex_img",attrs:{"src":require("@/assets/hex_dcomm.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }